/* global axios */
import ApiClient from './ApiClient';

const versionLockConfig = lockVersion => {
  if (lockVersion === undefined || lockVersion === null || lockVersion === '') {
    return {};
  }

  return { headers: { 'If-Match': `"${lockVersion}"` } };
};

class AutomationsAPI extends ApiClient {
  constructor() {
    super('automation_rules', { accountScoped: true });
  }

  clone(automationId) {
    return axios.post(`${this.url}/${automationId}/clone`);
  }

  versions(automationId) {
    return axios.get(`${this.url}/${automationId}/versions`);
  }

  publish(
    automationId,
    { versionId, lockVersion, publicationMetadata = {} } = {}
  ) {
    const payload = { publication_metadata: publicationMetadata };
    if (versionId) payload.version_id = versionId;

    return axios.post(
      `${this.url}/${automationId}/publish`,
      payload,
      versionLockConfig(lockVersion)
    );
  }

  simulate(automationId, { versionId, simulation = {} } = {}) {
    const payload = { simulation };
    if (versionId) payload.version_id = versionId;

    return axios.post(`${this.url}/${automationId}/simulate`, payload);
  }

  diff(automationId, params = {}) {
    return axios.get(`${this.url}/${automationId}/diff`, { params });
  }

  candidatePublishedComparison(automationId, params = {}) {
    return axios.get(
      `${this.url}/${automationId}/candidate_published_comparison`,
      { params }
    );
  }

  compareCandidatePublished(automationId, { versionId, comparison = {} } = {}) {
    const payload = { comparison: { ...comparison } };
    if (versionId) payload.comparison.version_id = versionId;

    return axios.post(
      `${this.url}/${automationId}/candidate_published_comparison`,
      payload
    );
  }
}

export default new AutomationsAPI();
